import { render, staticRenderFns } from "./paymentCallback.vue?vue&type=template&id=f58e958a&scoped=true&"
import script from "./paymentCallback.vue?vue&type=script&lang=js&"
export * from "./paymentCallback.vue?vue&type=script&lang=js&"
import style0 from "./paymentCallback.vue?vue&type=style&index=0&id=f58e958a&prod&scoped=true&lang=scss&"
import style1 from "./paymentCallback.vue?vue&type=style&index=1&id=f58e958a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58e958a",
  null
  
)

export default component.exports